import styled from 'styled-components'
import { rem } from 'polished'
import NestableClickable from 'components/Common/NestableClickable'

export const SelectableCard = styled(NestableClickable)`
  padding: ${rem(12)};
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
  border-radius: ${rem(12)};
  cursor: pointer;
  background-color: transparent;
  transition: background-color 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }

  &:not(:disabled):hover {
    border-color: ${props => props.theme.palette.brand.primary.hover};
  }

  &.selected {
    border: 2px solid ${props => props.theme.palette.brand.primary.normal};
  }

  &.selected:disabled {
    opacity: 1;
  }

  &.with-image {
    padding: 0;
    display: flex;
    align-items: stretch;
    overflow: hidden;
  }
`
